import { CrudHeader } from "../_common/CrudHeader";
import { CrudFormModal } from "../_common/CrudFormModal";
import { CrudDeleteModal } from "../_common/CrudDeleteModal";

import { PartnersController } from "./PartnersController";
import { PartnerForm } from "./components/form/PartnerForm";
import { PartnerTable } from "./components/table/PartnerTable";

import { translateKey as t } from "../../../locales/translation";
import { AppStore } from "~/stores/AppStore";

import "./Partners.scss";
import { useEffect, useMemo } from "react";

const Partners = ({ store }: { store: AppStore }) => {
  const partnersController = useMemo(() => new PartnersController(store), [store]);

  useEffect(() => {
    partnersController.loadDependencies();

    partnersController.crudCommon.enableKeyboardShortcuts();
    document.title = t("lblPartners", "Partners") + " - openFleet Pro";

    window.addEventListener("beforeunload", (event) => {
      if (partnersController.modifiedRows.length > 0) {
        event.returnValue = null;
      }
    });
  }, [partnersController]);

  const handleFormSave = async () => {
    try {
      await partnersController.formRef.validateFields();
      partnersController.saveFormPartner();
    } catch (error) {
      console.error("Validation Failed:", error);
    }
  };

  const { isReadOnly } = partnersController;

  return (
    <div className="Partners_Main_Container">
      <CrudHeader title={t("lblPartners", "Partners")} controller={partnersController} />
      <PartnerTable controller={partnersController} store={store} />
      <CrudFormModal
        controller={partnersController}
        form={<PartnerForm controller={partnersController} />}
        onSave={() => handleFormSave()}
        entity="partner"
        itemName={t("lblPartner", "Partner")}
        activeSwitch={{
          propertyAccessor: "active",
          title: t("lblActive", "Active"),
          disabled: isReadOnly,
        }}
        centered
        canMaximize
        bodyStyle={{ padding: "0px 16px 16px 16px", maxHeight: "75vh", overflowY: "auto" }}
        size={partnersController.formModalSize}
      />
      <CrudDeleteModal modalProps={partnersController.deleteModal} controller={partnersController} />
    </div>
  );
};

export { Partners };
